var _style, _circle, _path, _path2, _g, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#00375F;}\n\t.st2{fill:#FF920A;}\n\t.st3{opacity:0.6;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#91B3FA;}\n\t.st6{fill:url(#SVGID_2_);}\n\t.st7{opacity:0.78;fill:#FFFFFF;}\n\t.st8{fill:url(#SVGID_3_);}\n\t.st9{fill:url(#SVGID_4_);}\n\t.st10{fill:url(#SVGID_5_);}\n\t.st11{fill:url(#SVGID_6_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.6196,
    y1: 213.5853,
    x2: 72.5669,
    y2: 75.3909
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 100,
    cy: 100,
    r: 100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.8,164.6c0,1.6,1.3,3,3,3h161.7c1.6,0,3-1.3,3-3l1.3-92.9c0-1.6-1.9-4.9-5.5-4.6L23.3,63 c-2.1-0.1-4.1,0.7-5.5,2.2c-1.5,1.5-2.3,3.4-2.2,5.5L17.8,164.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.7,161.8c0,1.6,1.3,2.8,2.8,2.8h155c1.6,0,2.8-1.3,2.8-2.8l1.3-84.4c-0.1-5.1-4.6-6.9-7.3-6.8L23.9,66.6 c-1.4,0-2.9,0.5-3.9,1.5c-1,1-1.6,2.4-1.6,3.9L20.7,161.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M179.8,121.7C179.8,121.7,179.7,121.7,179.8,121.7c-0.2,0-0.4-0.2-0.4-0.4l0.1-6.8c0-0.2,0.2-0.4,0.4-0.4 c0,0,0,0,0,0c0.2,0,0.4,0.2,0.4,0.4l-0.1,6.8C180.2,121.5,180,121.7,179.8,121.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M180,104.9C180,104.9,180,104.9,180,104.9c-0.2,0-0.4-0.2-0.4-0.4l0.4-26.2c0-1.6-0.5-2.8-1.4-3.7 c-1.7-1.7-4.5-1.6-4.6-1.6l-48.4-1.3c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4l48.4,1.3c0.3,0,3.2-0.1,5.2,1.8 c1.1,1,1.7,2.5,1.7,4.3l-0.4,26.2C180.4,104.8,180.2,104.9,180,104.9z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5,175.4H195c0.2,0,0.4-0.2,0.4-0.4v-7.4c0-0.2-0.2-0.4-0.4-0.4H5c-0.2,0-0.4,0.2-0.4,0.4v7.4 C4.7,175.2,4.8,175.4,5,175.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M124,22.8l-96-0.6c-3.2,0-5.7,2.6-5.5,5.8l6.6,136.3h106.8l5.9-121.8L124,22.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.4842,
    y1: 13.6115,
    x2: 190.6406,
    y2: -29.6605
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M128,41.9c-3.1-0.1-5.5-2.8-5.3-5.9l1-13l18.1,19.4L128,41.9z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M73.2,48.8c8.6,0,41.7-0.1,50-0.1c1.1,0,1.9,1,1.8,2.2l0,0c0,1.2-0.9,2.1-1.9,2.1l-50,0.4 c-1,0-1.8-0.8-1.9-1.9l0-0.3C71.2,49.9,72.1,48.8,73.2,48.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M72.8,58.3c8.6,0,41.7-0.1,50-0.1c1.1,0,1.9,1,1.8,2.2l0,0c0,1.2-0.9,2.1-1.9,2.1l-50,0.4 c-1,0-1.8-0.8-1.9-1.9l0-0.3C70.8,59.4,71.7,58.3,72.8,58.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M42.9,72c13.3,0,64.4,0,77.3,0c1.6,0,2.9,1,2.9,2.2l0,0c0,1.2-1.3,2.1-2.8,2.1L43,76.6 c-1.5,0-2.8-0.8-2.9-1.9l0-0.3C39.9,73.1,41.2,72,42.9,72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M42.3,82c10.4,0,50.1-0.3,60.1-0.3c1.3,0,2.3,1,2.3,2.2l0,0c0,1.2-1,2.1-2.2,2.1l-60.1,0.6 c-1.2,0-2.1-0.8-2.3-1.9l0-0.3C39.9,83.1,41,82,42.3,82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M42.8,95.2c13.3,0,64.4,0,77.3,0c1.6,0,2.9,1,2.9,2.2l0,0c0,1.2-1.3,2.1-2.8,2.1l-77.2,0.3 c-1.5,0-2.8-0.8-2.9-1.9l0-0.3C39.8,96.2,41.1,95.2,42.8,95.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M41.6,105.4c10.4,0,50.3,0,60.4,0c1.3,0,2.3,1,2.3,2.2l0,0c0,1.2-1,2.1-2.2,2.1l-60.4,0.2 c-1.2,0-2.1-0.8-2.3-1.9l0-0.3C39.2,106.4,40.3,105.4,41.6,105.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M42.1,118.8c13.3,0,64.4,0,77.3,0c1.6,0,2.9,1,2.9,2.2l0,0c0,1.2-1.3,2.1-2.8,2.1l-77.2,0.3 c-1.5,0-2.8-0.8-2.9-1.9l0-0.3C39.1,119.9,40.4,118.8,42.1,118.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M41.3,128.9c10.4,0,50.3,0,60.4,0c1.3,0,2.3,1,2.3,2.2l0,0c0,1.2-1,2.1-2.2,2.1l-60.4,0.2 c-1.2,0-2.1-0.8-2.3-1.9l0-0.3C38.9,130,40,128.9,41.3,128.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M42.9,142.2c13.3,0,64.4,0,77.3,0c1.6,0,2.9,1,2.9,2.2l0,0c0,1.2-1.3,2.1-2.8,2.1L43,146.8 c-1.5,0-2.8-0.8-2.9-1.9l0-0.3C39.9,143.3,41.2,142.2,42.9,142.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M42.1,153.4c10.3,0,49.7-0.1,59.7-0.1c1.3,0,2.3,1,2.2,2.2l0,0c0,1.2-1,2.1-2.2,2.1l-59.6,0.3 c-1.1,0-2.1-0.8-2.2-1.9l0-0.3C39.8,154.5,40.8,153.4,42.1,153.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -3545.9277,
    y1: 101.8687,
    x2: -3542.1741,
    y2: 101.8687,
    gradientTransform: "matrix(-1 0 0 1 -3426.9888 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M118.4,103.7c-0.4,0.3-1.8-0.4-2.7-0.8c-0.4-0.2-0.6-0.7-0.5-1.2c0.2-0.7,0.6-1.5,1-1.6 C116.9,99.8,120.2,102.3,118.4,103.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,116.5L83.3,77.7l-5.8,16l109.1,39.9c2.3,0.8,4.9-0.1,6.1-2.2c1.3-2.2,2.5-5.6,2.6-10.7 C195.4,118.8,194.2,117.1,192.4,116.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.5,73.5l15.1,1.9c0,2.1-0.7,4.8-3,7.8L49,74.9C48.3,74.5,48.7,73.4,49.5,73.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -3483.9209,
    y1: 64.5005,
    x2: -3561.134,
    y2: 143.8526,
    gradientTransform: "matrix(-1 0 0 1 -3426.9888 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M83.3,77.7c0.7,10.1-5.8,16-5.8,16L61.6,83.2c2.3-3.1,3-5.8,3-7.8L83.3,77.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -3531.0071,
    y1: 66.8169,
    x2: -3600.6897,
    y2: 138.4299,
    gradientTransform: "matrix(-1 0 0 1 -3426.9888 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M191.1,121.4c0.1,0,0.3-0.1,0.3-0.2c0.1-0.2,0-0.4-0.2-0.4L86.8,83.9c-0.2-0.1-0.4,0-0.4,0.2 c-0.1,0.2,0,0.4,0.2,0.4L191,121.4C191,121.4,191,121.4,191.1,121.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -3529.2056,
    y1: 73.1102,
    x2: -3598.8882,
    y2: 144.7233,
    gradientTransform: "matrix(-1 0 0 1 -3426.9888 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M189.3,127.7c0.1,0,0.3-0.1,0.3-0.2c0.1-0.2,0-0.4-0.2-0.4L84.9,90.2c-0.2-0.1-0.4,0-0.4,0.2 c-0.1,0.2,0,0.4,0.2,0.4l104.4,36.9C189.2,127.7,189.2,127.7,189.3,127.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDocuments);
export default __webpack_public_path__ + "static/media/no-documents.4f0e83d34b5e4e5d8f5454cc92fed3f3.svg";
export { ForwardRef as ReactComponent };